export default __webpack_public_path__ + "static/media/marquee5.52860636.png";